/**
 * @generated SignedSource<<9ddee645b37638c29f6c6f116666d272>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoToolbarButtonTeams_teams$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarButtonTeamsDetail_teams">;
  readonly " $fragmentType": "TodoToolbarButtonTeams_teams";
}>;
export type TodoToolbarButtonTeams_teams$key = ReadonlyArray<{
  readonly " $data"?: TodoToolbarButtonTeams_teams$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoToolbarButtonTeams_teams">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TodoToolbarButtonTeams_teams",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoToolbarButtonTeamsDetail_teams"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "9f8130ed93ce0aa0464c171e0d99eab6";

export default node;
